
export const getEditNavigationState = ({
    row,
    tabs,
    pantallas,
    tipoModuloEnum,
    tipoModuloConIndicacion
}) => {
    const pantallasFiltered = pantallas.filter(x => !!x.id && x.modulos.some(m => m.id === row.idTipoModulo));

    const auxDataState = {
        idEvaluacion: row.idEvaluacion,
        idDelegacion: row.idDelegacion,
        idTipoModulo: row.idTipoModulo,
        delegacion: row.delegacion,
        edit: false,
        notificationData: row,
        tipoNotificacion: tabs.find(tab => tab.active)?.notificationName,
        // si row.RI es null, significa que no se tiene que generar RI, en caso de 0 o 1 deberia aparecer opcion de generacion de RI
        // PR no genera RI
        canGenerateRI: (!!pantallasFiltered.length) && (row.rI !== null) && (row.tipoEvaluacion !== "PR")
    };

    const hasProfessionalScreen = pantallasFiltered.some(x => x.displayName.includes("Reco. Prof"));

    const hasEsquemaBAP = [tipoModuloEnum?.AP, tipoModuloEnum?.NPID].includes(row.idTipoModulo);

    const tipoModulosIndication = Object.values(tipoModuloConIndicacion || {});

    const hasIndication = tipoModulosIndication.includes(row.idTipoModulo);

    return {
        auxDataState,
        flags: {
            hasProfessionalScreen,
            hasEsquemaBAP,
            hasIndication,
            moduloCP: row.idTipoModulo === tipoModuloEnum?.CP,
            moduloCD: row.idTipoModulo === tipoModuloEnum?.CD,
            moduloHE: row.idTipoModulo === tipoModuloEnum?.HE,
            moduloSSAE: row.idTipoModulo === tipoModuloEnum?.SSAE,
            moduloSI: row.idTipoModulo === tipoModuloEnum?.SI
        }
    };
};

export const getEditRouteByTab = (activeTabEnum) => {
    switch (activeTabEnum) {
        case 'ASIGNACION':
            return '/asignacionValidacionResumenIngreso/asignar';
        case 'VALIDACION':
            return '/asignacionValidacionResumenIngreso/validar';
        case 'INGRESO_INDICACION':
            return '/asignacionValidacionResumenIngreso/ingresoIndicacion';
        case 'CAMBIO_INDICACION':
            return '/asignacionValidacionResumenIngreso/cambioIndicacion';
        case 'CONFIRMAR_EQUIPO':
            return '/asignacionValidacionResumenIngreso/confirmarEquipo';
        case 'CAMBIO_PROGRAMA':
            return '/asignacionValidacionResumenIngreso/cambioPrograma';
        default:
            return null;
    }
};